import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Menu from "./Menu";
import DefaultSearchBar from "./DefaultSearchBar";
import {
  getMenuActiveFromPath,
  shouldHideVisitorChrome,
  shouldShowDefaultSearch,
} from "./menuRouteHelpers";

const VisitorChrome = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const hidden = shouldHideVisitorChrome(pathname);
  const menuActive = getMenuActiveFromPath(pathname);
  const showDefaultSearch = shouldShowDefaultSearch(pathname);

  useEffect(() => {
    if (hidden) {
      document.body.classList.remove("visitor-app");
      document.body.classList.remove("visitor-default-search");
      return undefined;
    }

    document.body.classList.add("visitor-app");
    if (showDefaultSearch) {
      document.body.classList.add("visitor-default-search");
    } else {
      document.body.classList.remove("visitor-default-search");
    }

    return () => {
      document.body.classList.remove("visitor-app");
      document.body.classList.remove("visitor-default-search");
    };
  }, [hidden, showDefaultSearch]);

  if (hidden) {
    return null;
  }

  return (
    <>
      {showDefaultSearch && (
        <div className="search-box visitor-glass-header" id="search_box">
          <DefaultSearchBar />
        </div>
      )}
      <Menu active={menuActive} />
    </>
  );
};

export default VisitorChrome;
